import { PessoaFisica } from './pessoa-fisica';

export class Dependentes {

	id: number;
	idFuncionario: number;
	descricaoGrauParentesco: string;
	descricaoOutrasInformacoes: string;
	dataDesligamento: Date;
	descricaoDesligamento: string;
	pessoaFisica: PessoaFisica;
	usuarioAlteracao: number;

}



    



